import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as linkDestination from './link-destination'

export const DOC = gql`
  ${linkDestination.DOC}
  fragment FragmentLink on Link {
    goto {
      ...FragmentLinkDestination
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentLinkFragment,
  ents.core.display.Link
>({
  goto: linkDestination.TRANSFORMER,
})

/**
 * Similar to {@link TRANSFORMER}, but produces a {@link Required}<{@link ents.core.display.Link}>
 */
export const TRANSFORMER_FOR_REQUIRED_LINK = graphql.transformers.OUT.object<
  graphql.schema.FragmentLinkFragment,
  Required<ents.core.display.Link>
>({
  goto: graphql.transformers.OUT.validate(
    linkDestination.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
